var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.badges && _vm.badges.length)?_c('div',[_c('v-card-title',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.title || _vm.$t('profile.my-badges-title')))]),_c('RaceBadgesGrid',{attrs:{"badges":_vm.badges,"compact":"","xs":_vm.xs}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }